/**
 * The height a summary card stands at: the one thing a tab leads with, before its lists.
 *
 * Care's score and Billing's membership are the same kind of object in the same position, so they
 * are the same height, and the number lives here rather than in either of them — set twice it
 * would drift the first time one of them gained a line.
 *
 * Taken from the score card's own content: a forty-point label row, the numeral in the display
 * face and its measure, at the padding a note carries.
 */
export const SUMMARY_CARD_HEIGHT = 211
